"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
const attempt = (attemptNumber, fn, options, data) => {
    return fn(data).catch((err) => {
        if (attemptNumber < options.attempts) {
            return attempt(attemptNumber + 1, fn, options, data);
        }
        return Promise.reject(err);
    });
};
exports.retry = (fn, options) => async (data) => attempt(1, fn, options, data);
exports.default = exports.retry;
